import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import ExitIcon from '../../../../images/exit-modal_outlined.svg'
import FailedIcon from '../../../../images/reject-transaction.svg'
import { useAppDispatch } from '../../../../store'
import { unbindTxSlice } from '../../../../store/web3/unbind.side-effects'

export const TxFailedModal: React.FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    ref.current?.focus()
    ref.current?.scrollIntoView()
  })

  return (
    <StyledTxBackground
      ref={ref}
      tabIndex={-1}
      onKeyDown={({ key }) => {
        if (key === 'Escape') {
          dispatch(unbindTxSlice.actions.TX_CLEARED())
        }
      }}
    >
      <TxNft>
        <TxNftBackground>
          <TxNftBorder>
            <ExitButton
              onClick={() => {
                dispatch(unbindTxSlice.actions.TX_CLEARED())
              }}
            >
              <img src={ExitIcon} alt="exit button" />
            </ExitButton>
            <StyledH1>{t('Transaction Failed')}</StyledH1>

            <StyledImg src={FailedIcon} alt="Warning Icon" />
            <DismissButton
              onClick={() => {
                dispatch(unbindTxSlice.actions.TX_CLEARED())
              }}
            >
              {t('Dismiss')}
            </DismissButton>
          </TxNftBorder>
        </TxNftBackground>
      </TxNft>
    </StyledTxBackground>
  )
}

const ExitButton = styled.button`
  width: 2rem;
  position: absolute;
  top: 1rem;
  right: 1rem;
`

const StyledImg = styled.img`
  justify-self: center;
  align-self: center;
`

const DismissButton = styled.button`
  color: white;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 70%;
  font-weight: 700;
  font-family: 'Open Sans';
  font-size: 20px;
  font-weight: 400;

  background: #ff0000;
  box-sizing: border-box;

  border-radius: 18px;
  margin-top: 2rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;

  @media (min-width: 1200px) {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
`

const StyledH1 = styled.h1`
  font-weight: 500;
`

const TxNftBackground = styled.div`
  background: black;
  @media (min-width: 200px) {
    padding: 1rem;
  }
  @media (min-width: 1200px) {
    padding: 2rem;
  }
`

const TxNftBorder = styled.div`
  border: 2px solid #ff0000;
  position: relative;

  display: grid;
  grid-template-rows: min-content 1fr min-content min-content;
  row-gap: 2rem;
  justify-items: center;

  @media (min-width: 200px) {
    padding: 1rem;
  }
  @media (min-width: 1200px) {
    width: 700px;
    padding: 4rem;
  }
`

const TxNft = styled.div`
  width: 100%;
  height: 100%;

  @media (min-width: 200px) {
  }
  @media (min-width: 1200px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

const StyledTxBackground = styled.section`
  z-index: 1001;
  background: rgba(0, 0, 0, 0.795);
  width: 100%;

  @media (min-width: 200px) {
    position: fixed;
    bottom: 0;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  @media (min-width: 750px) {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }
`
